import React from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
} from "@mui/material";
import DvrIcon from "@mui/icons-material/Dvr";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { DataGrid } from "@mui/x-data-grid";
import { durationList, sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  setState,
  getAnalyzeTradeProducts,
  getAnalyzeTradeForm,
  getAnalyzeTradeStrength,
  ExportHQReport,
  GetScenarioBySalesOrgAndMolecule,
  GetMoleculeBySalesOrg,
  GetdatasourceForScenario,
  GetProductForScenarioAndMolecule,
  GetHQReportData,
  GetCountyBySalesOrg
} from "../analyzeSlice";
import _ from "lodash";

import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import CollapseSection from "../../../components/ui/CollapseSection";
import MultiSelectRecords from "./MultiSelectRecords";

const selectWidth = sizes.w230;
const selectHeight = sizes.h35;

export default function TradeDetails() {
  const [validate, setValidate] = useState({
    countryValidated: false,
    productValidated: false,
    formValidated: false,
    strengthValidated: false,
    durationValidated: false,
  });

  const [countryTD, setCountryTD] = useState("");

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const loginState = useSelector((store) => store.login);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    selectedTradeProduct,
    selectedTradeForms,
    selectedAnalysisTypeID,
    duration,
    molecules,
    HQScenarios,
    Products,
    DataSources,
    moleculeSelected,
    countrySelected,
    scenarioSelected,
    productSelected,
    dataSourceSelected,
    HQReportData,
    individualCountries,
    individualCountrySelected
  } = state;

  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  const SalesOrgData = countries.map((country) => ({
    RecordName: country.countryName,
    RecordID: country.countryID,
  }));
  const ScenarioData = HQScenarios.map((scenario) => ({
    RecordName: scenario.scenario,
    RecordID: scenario.id,
  }));
  const ProductData = Products.map((product) => ({
    RecordName: product.packGroupOrSKUName,
    RecordID: product.packGroupOrSKUID,
  }));
  const DataSourceData = DataSources.map((dataSource) => ({
    RecordName: dataSource.dataSourceName,
    RecordID: dataSource.dataSourceID,
  }));
  const MoleculeData = molecules.map((molecule) => ({
    RecordName: molecule.molecule
  }));

  const CountryData = individualCountries.map((country) => ({
    RecordName: country,
  }));

  let columns = [
    {
      field: "geoName",
      headerName: "Sales Org",
      flex: 1
    },
    {
      field: "country",
      headerName: "Country",
      flex: 1,
    },
    {
      field: "molecule",
      headerName: "Molecule",
      flex: 1
    },
    {
      field: "scenarioName",
      headerName: "Scenario Name",
      flex: 1
    },
    {
      field: "SKU",
      headerName: "clientPackCode",
      flex: 1
    },
    {
      field: "packName",
      headerName: "SKU Description",
      flex: 1
    },
    {
      field: "period",
      headerName: "Period",
      flex: 1
    },
    {
      field: "value",
      headerName: "Quantity",
      flex: 1
    },
    {
      field: "dataSourceName",
      headerName: "DataSource",
      flex: 1
    },
  ];

  const FilterSelectedColumns = (selColumns, data) => {
    let newData = [];
    //let orgData = data;

    for (let i = 0; i < data.length; i++) {
      let newObj = {};
      for (let j = 0; j < selColumns.length; j++) {
        newObj[selColumns[j].headerName] = data[i][selColumns[j].field];
      }
      newData.push(newObj);

    }
    return newData;

  }

  useEffect(() => {
    if (selectedCountryID !== "") {
      //getScenariosForCountry();
    }
  }, [selectedCountryID]);

  useEffect(() => {
    if (moleculeSelected != null && moleculeSelected !== "" && moleculeSelected.length > 0
      && countrySelected !== null && countrySelected !== "" && countrySelected.length > 0) {
      let ids = SalesOrgData.filter((item) => countrySelected.includes(item.RecordName)).map((item) => item.RecordID);
      const obj = {
        moleculeList: moleculeSelected,
        geoID: ids,
      };
      dispatch(GetScenarioBySalesOrgAndMolecule(obj));
    } else {
      dispatch(setState("HQScenarios", []));
      dispatch(setState("scenarioSelected", []));
    }

  }, [moleculeSelected, countrySelected])

  useEffect(() => {
    if (countrySelected !== null && countrySelected !== "" && countrySelected.length > 0) {
      let ids = SalesOrgData.filter((item) => countrySelected.includes(item.RecordName)).map((item) => item.RecordID);
      dispatch(GetCountyBySalesOrg(ids));
      dispatch(GetMoleculeBySalesOrg(ids));
    } else {
      dispatch(setState("molecules", []));
      dispatch(setState("moleculeSelected", []));
      dispatch(setState("individualCountries", []));
      dispatch(setState("individualCountrySelected", []));
    }
  }, [countrySelected])

  useEffect(() => {
    if (scenarioSelected !== null && scenarioSelected !== "" && scenarioSelected.length > 0) {
      let ids = ScenarioData.filter((item) => scenarioSelected.includes(item.RecordName)).map((item) => item.RecordID);
      dispatch(GetdatasourceForScenario(ids));
    } else {
      dispatch(setState("DataSources", []));
      dispatch(setState("dataSourceSelected", []));
    }
  }, [scenarioSelected])

  useEffect(() => {
    if (scenarioSelected !== null && scenarioSelected !== "" && scenarioSelected.length > 0 &&
      moleculeSelected !== null && moleculeSelected !== "" && moleculeSelected.length > 0) {
      let ids = ScenarioData.filter((item) => scenarioSelected.includes(item.RecordName)).map((item) => item.RecordID);
      const obj = {
        moleculeList: moleculeSelected,
        scenarioIdList: ids,
      };
      dispatch(GetProductForScenarioAndMolecule(obj));
    } else {
      dispatch(setState("Products", []));
      dispatch(setState("productSelected", []));
    }
  }, [scenarioSelected, moleculeSelected])

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedTradeProduct", ""));
    dispatch(setState("duration", null));
    dispatch(setState("clearAnalyzeTradeDetails", false));

    dispatch(setState("tradeProducts", []));

  }, []);

  function setDuration(event) {
    const d = event.target.value;
    if (d) {
      setValidate({
        ...validate,
        durationValidated: true,
      });
    }
    dispatch(setState("duration", d));
  }

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [2000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  useEffect(() => {
    const rowsWithId = HQReportData.map((item, index) => ({
      ...item,
      id: index + 1
    }));
    setRows(rowsWithId);
  }, [HQReportData]);

  function exportDataAsFile(isPdf) {
    const obj = {
      listHQReportTableData: FilterSelectedColumns(columns, rows)
    }
    dispatch(ExportHQReport(obj));
  }

  function handleDisplay() {
    if (countrySelected === null || countrySelected.length === 0) {
      displayAlert("Sales Org");
      return;
    }
    if (individualCountrySelected === null || individualCountrySelected.length === 0) {
      displayAlert("Country");
      return;
    }
    if (moleculeSelected === null || moleculeSelected.length === 0) {
      displayAlert("Molecule");
      return;
    }
    if (scenarioSelected === null || scenarioSelected.length === 0) {
      displayAlert("Scenario");
      return;
    }
    if (productSelected === null || productSelected.length === 0) {
      displayAlert("Product");
      return;
    }
    if (duration === null || duration === "") {
      displayAlert("Duration");
      return;
    }
    if (dataSourceSelected === null || dataSourceSelected.length === 0) {
      displayAlert("Datasource");
      return;
    }

    let geoIdList = SalesOrgData.filter((item) => countrySelected.includes(item.RecordName)).map((item) => item.RecordID);
    let scenarioIdList = ScenarioData.filter((item) => scenarioSelected.includes(item.RecordName)).map((item) => item.RecordID);
    let productIdList = ProductData.filter((item) => productSelected.includes(item.RecordName)).map((item) => item.RecordID);
    let dataSourceList = DataSourceData.filter((item) => dataSourceSelected.includes(item.RecordName)).map((item) => item.RecordID);
    const obj = {
      geoIdList: geoIdList,
      countryList: individualCountrySelected,
      scenarioIdList: scenarioIdList,
      moleculeList: moleculeSelected,
      duration: duration,
      skuIdList: productIdList,
      dataSourceList: dataSourceList
    };

    //dispatch(setState("clearAnalyzeTradeDetails", true));

    dispatch(GetHQReportData(obj));
  }

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Grid
          container
          // columns={12}
          spacing={2}
        >
          <Grid
            item
            sm={6} md={4} lg={2}
          >
            <MultiSelectRecords Records={SalesOrgData} name={'Sales Org'} />
          </Grid>
          <Grid
            item
            sm={6} md={4} lg={2}
          >
            <MultiSelectRecords Records={CountryData} name={'Country'} />
          </Grid>

          <Grid
            item
            sm={6} md={4} lg={2}
          >
            <MultiSelectRecords Records={MoleculeData} name={'Molecule'} />
          </Grid>

          <Grid
            item
            sm={6} md={4} lg={2}
          >
            <MultiSelectRecords Records={ScenarioData} name={'Scenario'} />
          </Grid>
          <Grid
            item
            sm={6} md={4} lg={2}
          >
            <MultiSelectRecords Records={ProductData} name={'Product'} />
          </Grid>
          <Grid item sm={6} md={2} lg={2}>
            <FormControl>
              <InputLabel>Duration</InputLabel>
              <Select
                value={duration}
                label="Duration"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={setDuration}
              >
                {durationList.map((duration, index) => {
                  return (
                    <MenuItem key={index} value={duration.value}>
                      {duration.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            sm={6} md={4} lg={2}
          >
            <MultiSelectRecords Records={DataSourceData} name={'DataSource'} />
          </Grid>

          <Grid item sm={6} md={4} lg={1}>
            <Button
              startIcon={<DvrIcon />}
              sx={{
                bgcolor: "blue.main",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
                },
                //mt: 1.5
              }}
              onClick={handleDisplay}
            >
              Display
            </Button>
          </Grid>
        </Grid>
        {alert.alertDisplay && (
          <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
        )}
      </Box>
      {rows.length > 0 && (
        <CollapseSection title="  HQ Report">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <IconButton onClick={(e) => exportDataAsFile(false)}>
              <GridOnIcon sx={{ color: "green.main" }} />
            </IconButton>
            {/* <IconButton onClick={(e) => exportDataAsFile(true)}>
              <PictureAsPdfIcon sx={{ color: "red.main" }} />
            </IconButton> */}
          </Box>

          <Box sx={{ mt: 3 }}>
            <DataGrid
              disableColumnMenu
              rows={rows || []}
              columns={columns}
              getRowId={(row) => row?.id}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                  },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
              sx={{
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  fontWeight: "bold !important",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal",
                  fontWeight: "bold",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeader": {
                  // Forced to use !important since overriding inline styles
                  height: "unset !important",
                },
                "& .MuiDataGrid-columnHeaders": {
                  // Forced to use !important since overriding inline styles
                  maxHeight: "168px !important",
                },
              }}
            />
          </Box>
        </CollapseSection>
      )}
    </>
  );
}
